import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { ApiResponse } from "../../../api/master/axiosIndex";
import { tasksApis } from "../../../api/NewTasks";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { Card } from "antd";
import StatusTimeLine from "../statusTimeLine/StatusTimeLine";

interface TaskStatusTimeLineProps {
  isActive?: boolean;
}

const TaskStatusTimeLine: React.FC<TaskStatusTimeLineProps> = ({
  isActive = false,
}) => {
  const [timeLineData, setTimeLineData] = React.useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  const { id: projectId, extra: extraData } = location.state || {};
  const { data: TaskListInDetailModal } = useSelector(
    (state: RootState) => state.TaskListInDetailModal
  );
  useEffect(() => {
    if (isActive) {
      getStatusTimeLineData();
    }
  }, [isActive]);
  const getStatusTimeLineData = async () => {
    try {
      const apiResponse: ApiResponse = await tasksApis.fetchTaskStatusTimeline(
        projectId,
        TaskListInDetailModal.id
      );
      const { data, status } = apiResponse;
      if (status) {
        console.log("data", data);
        setTimeLineData(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Card className="card-bordered mt-3" style={{ padding: "20px 50px" }}>
      <StatusTimeLine transitions={timeLineData} />
    </Card>
  );
};

export default TaskStatusTimeLine;
